<template>
  <footer>
    <v-sheet color="primary">
      <MenuWidget />
    </v-sheet>

    <v-container
      class="
        py-5
        d-flex
        flex-column flex-sm-row
        justify-center
        align-center
        text-center
      "
    >
      <a
        class="d-flex mb-2 mb-sm-0"
        href="https://www.mrxweb.com.br/"
        target="_blank"
      >
        <img
          loading="lazy"
          src="../../assets/img/mrxweb.svg"
          alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
          title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
          height="20px"
        />
      </a>
      <div class="primary--text text-caption ml-sm-6">
        Copyright ©
        <b class="font-weight-bold">{{ year }} {{ informations.name }}</b
        >.
        <span class="d-block d-sm-inline-block">
          Todos os direitos reservados.
        </span>
      </div>
    </v-container>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";
import MenuWidget from "../widgets/MenuWidget.vue";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
  },
  components: {
    MenuWidget,
  },
};
</script>
